import { CellRendererItem } from "./cell-renderer-item";
import { DefaultCellRendererComponent } from "./default-cell-renderer.component";
import { GridRendererProvider } from "./grid-renderer-provider.interface";
import { HeaderRendererItem } from "./header-renderer-item";
import { DefaultHeaderRendererComponent } from "./default-header-renderer.component";
import { DefaultRowNumberHeaderRendererComponent } from "./default-row-number-header-renderer.component";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class DefaultGridRendererProvider implements GridRendererProvider {
  private rowNumHeaderRenderer: HeaderRendererItem = new HeaderRendererItem(DefaultRowNumberHeaderRendererComponent);
  private headerRenderer: HeaderRendererItem = new HeaderRendererItem(DefaultHeaderRendererComponent);
  private cellRenderer: CellRendererItem = new CellRendererItem(DefaultCellRendererComponent);

  getHeaderHeight(): number {
    return 50;
  }

  public getRowNumberHeaderRenderer(): HeaderRendererItem {
    return this.rowNumHeaderRenderer;
  }

  public getHeaderRenderer(colId: string): HeaderRendererItem {
    return this.headerRenderer;
  }

  public getCellRenderer(colId: string): CellRendererItem {
    return this.cellRenderer;
  }
}
